/* ============================================================
 * Linen Trail — Transparency
 * ------------------------------------------------------------
 * 1. Moves the badge above the product title.
 * 2. Moves the cards before the first accordion tab.
 * 3. Hides the now-empty section wrapper.
 * 4. Keeps the link in sync with the selected fabric colour.
 *
 * Debug: window.LINEN_TP_DEBUG = true; location.reload();
 * ========================================================== */
(function () {
  'use strict';

  var DEBUG = !!window.LINEN_TP_DEBUG;
  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[LT-transparency]'].concat([].slice.call(arguments)));
    }
  }

  /* -- DOM placement ----------------------------------------- */

  function findFirst(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) { log('matched', selectors[i]); return el; }
    }
    return null;
  }

  function placeElements() {
    var section = document.querySelector('[data-transparency-section]');
    if (!section) { log('No section to relocate'); return; }
    if (section.dataset.placed === '1') return; // already moved
    section.dataset.placed = '1';

    var badge = section.querySelector('.tp-badge');
    var cards = section.querySelector('.transparency-cards');

    // --- Badge → just before the product title ---
    var title = findFirst([
      '.product-single__title',
      '.product__title',
      '.product-single__meta h1',
      '.product__meta h1',
      'h1.product-title',
      'h1.h1',
      '[data-product-title]',
      'h1'
    ]);
    if (badge && title && title.parentNode) {
      title.parentNode.insertBefore(badge, title);
      log('Badge placed above title');
    } else {
      log('Badge stays in section (title not found)');
    }

    // --- Cards → just before the first tab/accordion block ---
    var firstTab = findFirst([
      '.product-block-tab',
      '.product-block--tab',
      '.collapsibles-wrapper',
      '.collapsible-trigger-btn',
      '.product__accordion',
      '.product-single__description'
    ]);
    if (cards && firstTab && firstTab.parentNode) {
      cards.classList.add('transparency-cards--inline');
      firstTab.parentNode.insertBefore(cards, firstTab);
      log('Cards placed before first tab');
    } else {
      log('Cards stay in section (tab not found)');
    }

    // --- Hide the now-empty wrapper so it doesn't add blank space ---
    var inner = section.querySelector('.transparency-section__inner');
    if (inner && !inner.querySelector('.tp-badge') && !inner.querySelector('.transparency-cards')) {
      section.style.display = 'none';
      log('Empty section wrapper hidden');
    }
  }

  /* -- Badge → smooth scroll to cards section ---------------- */

  function attachBadgeScroll() {
    var badges = document.querySelectorAll('[data-transparency-scroll]');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (b.dataset.scrollAttached === '1') continue;
      b.dataset.scrollAttached = '1';
      b.addEventListener('click', function (e) {
        var href = this.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();

        // Account for any sticky header
        var offset = 80;
        var header = document.querySelector(
          '.site-header.is-sticky, .header--sticky, .site-header[data-sticky="true"], .shopify-section-header-sticky'
        );
        if (header) {
          var hRect = header.getBoundingClientRect();
          if (hRect.bottom > 0 && hRect.bottom < 200) offset = hRect.bottom + 12;
        }

        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        if ('scrollBehavior' in document.documentElement.style) {
          window.scrollTo({ top: top, behavior: 'smooth' });
        } else {
          window.scrollTo(0, top);
        }
        // brief highlight when arriving
        target.classList.remove('transparency-cards--flash');
        // force reflow then re-add to restart animation
        void target.offsetWidth;
        target.classList.add('transparency-cards--flash');
      });
    }
  }

  /* -- Variant → URL sync ------------------------------------ */

  var COLOR_RE = /colou?r|fabric|shade/i;

  function findForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function getSelectedColor() {
    var form = findForm();
    if (!form) return null;

    var radios = form.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var fs = r.closest && r.closest('fieldset');
      var legend = fs ? fs.querySelector('legend, label, .variant__label-info, .single-option-radio__label') : null;
      var legendText = legend ? legend.textContent : '';
      if (COLOR_RE.test(r.name || '') || COLOR_RE.test(legendText)) {
        return (r.value || '').trim();
      }
    }

    var selects = form.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var s = selects[j];
      var labelText = '';
      if (s.id) {
        var lbl = form.querySelector('label[for="' + s.id + '"]');
        if (lbl) labelText = lbl.textContent;
      }
      if (COLOR_RE.test(s.name || '') || COLOR_RE.test(labelText)) {
        return (s.value || '').trim();
      }
    }

    if (radios.length === 1) return (radios[0].value || '').trim();
    return null;
  }

  function update() {
    var dataEl = document.querySelector('[data-transparency-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }

    var color = getSelectedColor();
    var key = color ? color.toLowerCase().trim() : '';
    var url = (data.map && data.map[key]) || data['default'] || null;
    url = normalizeUrl(url);
    log('Colour:', color, '| URL:', url);

    var links = document.querySelectorAll('[data-transparency-link]');
    for (var i = 0; i < links.length; i++) {
      var el = links[i];
      if (url) {
        el.setAttribute('href', url);
        el.setAttribute('target', '_blank');
        el.setAttribute('rel', 'noopener nofollow');
      } else {
        el.setAttribute('href', '#');
      }
    }
  }

  function normalizeUrl(u) {
    if (u == null) return null;
    u = String(u).trim();
    if (!u) return null;

    // Aggressively strip any number of broken or correct protocol prefixes,
    // remembering the most recent scheme seen (default https). This handles:
    //   "https//KOSHA.AI/..."          (missing colon)
    //   "https://https//KOSHA.AI/..."  (double prefix from earlier fix attempts)
    //   "https://KOSHA.AI/..."         (correct)
    //   "//KOSHA.AI/..."               (protocol-relative)
    //   "KOSHA.AI/..."                 (bare domain)
    var scheme = 'https';
    var changed = true;
    while (changed) {
      changed = false;
      var m;
      // "https://" or "http://"
      if ((m = u.match(/^(https?):\/\//i))) {
        scheme = m[1].toLowerCase();
        u = u.slice(m[0].length);
        changed = true;
        continue;
      }
      // "https//" or "http//" (missing colon)
      if ((m = u.match(/^(https?)\/\//i))) {
        scheme = m[1].toLowerCase();
        u = u.slice(m[0].length);
        changed = true;
        continue;
      }
      // "//something"
      if (u.indexOf('//') === 0) {
        u = u.slice(2);
        changed = true;
      }
    }

    if (!u) return null;
    // Same-origin absolute path — leave as-is
    if (u.charAt(0) === '/') return u;
    // Rebuild with a clean scheme
    return scheme + '://' + u;
  }

  /* -- Init -------------------------------------------------- */

  function init() {
    placeElements();
    attachBadgeScroll();
    update();

    var form = findForm();
    if (form) form.addEventListener('change', update);

    document.addEventListener('variantChange', update);
    document.addEventListener('variant:change', update);

    var idInput = form && form.querySelector('[name="id"]');
    if (idInput) {
      var lastVal = idInput.value;
      setInterval(function () {
        if (idInput.value !== lastVal) {
          lastVal = idInput.value;
          update();
        }
      }, 600);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
})();